import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ValidatedCheckbox } from 'components';

import { BodyTextField, BrandedCheckbox, TitleTextField } from '../';

const TextForm: FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <TitleTextField required />
      <BodyTextField required />
      <ValidatedCheckbox name="is_shareable" label={t('posting:shareable')} color="primary" />
      <BrandedCheckbox />
    </Fragment>
  );
};

export default TextForm;
